





















import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
  name: 'catalog-product-list-toolbar-active-filters'
})

export default class extends Vue {
  @Prop({required: true}) dataSource: string;

  private get filters(): Array<object> {
    let allFilters =  this.$store.getters[`${this.dataSource}/activeFilters`];

    return allFilters.filter(option => {
      return option.hasOwnProperty('options');
    })
  }

  private disableFilter(filter, option): void {
    this.$store.dispatch(`${this.dataSource}/toggleFilter`, {
      filter: filter,
      option: option,
    });
  }
}
